import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {
  bulkAttemptsDelete,
  bulkCodDelete,
  bulkFreightDelete,
  bulkFuelDelete,
  bulkInsuranceDelete,
  bulkOdaDelete,
  bulkRtoDelete,
  deleteAttempts,
  deleteCod,
  deleteDestination,
  deleteFreight,
  deleteFuel,
  deleteInsurance,
  deleteOda,
  deleteOrigin,
  deleteProducts,
  deleteRto,
  deleteTransittime,
  editAttempts,
  editAttemptsState,
  editAttemptsbypatch,
  editCod,
  editCodState,
  editCodbypatch,
  editDestination,
  editFreight,
  editFreightState,
  editFreightsbypatch,
  editFuel,
  editFuelState,
  editFuelbypatch,
  editInsurance,
  editInsuranceState,
  editInsurancebypatch,
  editOda,
  editOdaState,
  editOdabypatch,
  editOrigin,
  editProducts,
  editProductsbypatch,
  editRto,
  editRtoState,
  editRtobypatch,
  editTransittime,
  exportDestination,
  exportOrigin,
  exportProducts,
  exportTransittime,
  exportrateAttempts,
  exportrateCod,
  exportrateFreight,
  exportrateFuel,
  exportrateInsurance,
  exportrateOda,
  exportrateRto,
  filterDestination,
  filterOrigin,
  filterProducts,
  getAttempts,
  getAttemptsbyId,
  getAttemptsrateTemplate,
  getCalType,
  getCalculationMethod,
  getCod,
  getCodbyId,
  getCodrateTemplate,
  getCollectionMethod,
  getContentType,
  getDeliveryStatus,
  getDestination,
  getDestinationTemplate,
  getFreight,
  getFreightbyId,
  getFreightsTemplate,
  getFuel,
  getFuelbyId,
  getFuelrateTemplate,
  getInsurance,
  getInsurancebyId,
  getInsurancerateTemplate,
  getOda,
  getOdabyId,
  getOdarateTemplate,
  getOrigin,
  getOriginTemplate,
  getPaymentType,
  getPeriod,
  getProductCategory,
  getProducts,
  getProductsContent,
  getProductsDimension,
  getProductsEvent,
  getProductsTemplate,
  getProductsWeight,
  getProductsbyId,
  getRto,
  getRtobyId,
  getRtosTemplate,
  getState,
  getStateRates,
  getStructure,
  getTransittime,
  getTransittimeTemplate,
  importAttempts,
  importCod,
  importDestination,
  importFreight,
  importFuel,
  importInsurance,
  importOda,
  importOrigin,
  importProducts,
  importRto,
  importTransittime,
  postAttempts,
  postCod,
  postDestination,
  postFreight,
  postFuel,
  postInsurance,
  postOda,
  postOrigin,
  postProducts,
  postRto,
  postTransittime,
} from "../../services/Masters/Masters_services";

const initialValues = {
  dimensionData: [],
  calculationData: [],
  calcData: [],
  periodData: [],
  collectionData: [],
  contentData: [],
  stateRateData:[],
  deliveryStatusData: [],
  paymentData: [],
  stateData: [],
  structureData: [],
  productEventData: [],
  productWeightData: [],
  productCategoryData: [],
  productContentData: [],
  productsData: [],
};

let mastersStore = (set) => ({
  ...initialValues,
  getProducts: async (params) => {
    const response = await getProducts(params);
    set({ productsData: response });
    return response;
  },
  filterProducts: async (params) => {
    const response = await filterProducts(params);
    set({ productsData: response });
    return response;
  },
  getProductsbyId: async (params) => {
    const response = await getProductsbyId(params);
    return response;
  },
  postProducts: async (params) => {
    const response = await postProducts(params);
    return response;
  },
  editProducts: async (params, data) => {
    const response = await editProducts(params, data);
    return response;
  },
  editProductsbypatch: async (params, data) => {
    const response = await editProductsbypatch(params, data);
    return response;
  },
  getProductsDimension: async () => {
    const response = await getProductsDimension();
    set({ dimensionData: response });
    return response;
  },
  getProductsEvent: async () => {
    const response = await getProductsEvent();
    set({ productEventData: response });
    return response;
  },
  getProductsWeight: async () => {
    const response = await getProductsWeight();
    set({ productWeightData: response });
    return response;
  },
  getProductCategory: async () => {
    const response = await getProductCategory();
    set({ productCategoryData: response });
    return response;
  },
  getProductsContent: async () => {
    const response = await getProductsContent();
    set({ productContentData: response });
    return response;
  },
  getCalType: async () => {
    const response = await getCalType();
    set({ calculationData: response });
    return response;
  },
  getCollectionMethod: async () => {
    const response = await getCollectionMethod();
    set({ collectionData: response });
    return response;
  },
   getCalculationMethod: async () => {
    const response = await getCalculationMethod();
    set({ calcData: response });
    return response;
  },
    getPeriod: async () => {
    const response = await getPeriod();
    set({  periodData: response });
    return response;
  },
  getContentType: async () => {
    const response = await getContentType();
    set({ contentData: response });
    return response;
  },
  getStateRates: async () => {
    const response = await getStateRates();
    set({ stateRateData: response });
    return response;
  },
  getDeliveryStatus: async () => {
    const response = await getDeliveryStatus();
    set({ deliveryStatusData: response });
    return response;
  },
  getPaymentType: async () => {
    const response = await getPaymentType();
    set({ paymentData: response });
    return response;
  },
  getState: async () => {
    const response = await getState();
    set({ stateData: response });
    return response;
  },
  getStructure: async () => {
    const response = await getStructure();
    set({ structureData: response });
    return response;
  },
  exportProducts: async (params) => {
    const response = await exportProducts(params);
    return response;
  },
  getProductsTemplate: async () => {
    const response = await getProductsTemplate();
    return response;
  },
  importProducts: async (params) => {
    const response = await importProducts(params);
    return response;
  },
  deleteProducts: async (params) => {
    const response = await deleteProducts(params);
    return response;
  },
  getFreight: async (params) => {
    const response = await getFreight(params);
    return response;
  },
  getFreightbyId: async (params) => {
    const response = await getFreightbyId(params);
    return response;
  },
  postFreight: async (params) => {
    const response = await postFreight(params);
    return response;
  },
  editFreight: async (params, data) => {
    const response = await editFreight(params, data);
    return response;
  },
  editFreightsbypatch: async (params, data) => {
    const response = await editFreightsbypatch(params, data);
    return response;
  },
  deleteFreight: async (params) => {
    const response = await deleteFreight(params);
    return response;
  },
  bulkFreightDelete: async (params) => {
    const response = await bulkFreightDelete(params);
    return response;
  },
  bulkRtoDelete: async (params) => {
    const response = await bulkRtoDelete(params);
    return response;
  },
  bulkCodDelete: async (params) => {
    const response = await bulkCodDelete(params);
    return response;
  },
  bulkOdaDelete: async (params) => {
    const response = await bulkOdaDelete(params);
    return response;
  },
  bulkFuelDelete: async (params) => {
    const response = await bulkFuelDelete(params);
    return response;
  },
  bulkInsuranceDelete: async (params) => {
    const response = await bulkInsuranceDelete(params);
    return response;
  },
  bulkAttemptsDelete: async (params) => {
    const response = await bulkAttemptsDelete(params);
    return response;
  },
  exportrateFreight: async (params) => {
    const response = await exportrateFreight(params);
    return response;
  },
  getFreightsTemplate: async (params) => {
    const response = await getFreightsTemplate(params);
    return response;
  },
  importFreight: async (params) => {
    const response = await importFreight(params);
    return response;
  },
  getRto: async (params) => {
    const response = await getRto(params);
    return response;
  },
  getRtobyId: async (params) => {
    const response = await getRtobyId(params);
    return response;
  },
  postRto: async (params) => {
    const response = await postRto(params);
    return response;
  },
  editRto: async (params, data) => {
    const response = await editRto(params, data);
    return response;
  },
  editRtobypatch: async (params, data) => {
    const response = await editRtobypatch(params, data);
    return response;
  },
  deleteRto: async (params) => {
    const response = await deleteRto(params);
    return response;
  },
  exportrateRto: async (params) => {
    const response = await exportrateRto(params);
    return response;
  },
  getRtosTemplate: async (params) => {
    const response = await getRtosTemplate(params);
    return response;
  },
  importRto: async (params) => {
    const response = await importRto(params);
    return response;
  },
  getCod: async (params) => {
    const response = await getCod(params);
    return response;
  },
  getCodbyId: async (params) => {
    const response = await getCodbyId(params);
    return response;
  },
  editCodbypatch: async (params, data) => {
    const response = await editCodbypatch(params, data);
    return response;
  },
  editCod: async (params, data) => {
    const response = await editCod(params, data);
    return response;
  },
  postCod: async (params) => {
    const response = await postCod(params);
    return response;
  },
  deleteCod: async (params) => {
    const response = await deleteCod(params);
    return response;
  },
  exportrateCod: async (params) => {
    const response = await exportrateCod(params);
    return response;
  },
  getCodrateTemplate: async (params) => {
    const response = await getCodrateTemplate(params);
    return response;
  },
  importCod: async (params) => {
    const response = await importCod(params);
    return response;
  },
  getOda: async (params) => {
    const response = await getOda(params);
    return response;
  },
  getOdabyId: async (params) => {
    const response = await getOdabyId(params);
    return response;
  },
  postOda: async (params) => {
    const response = await postOda(params);
    return response;
  },
  editOda: async (params, data) => {
    const response = await editOda(params, data);
    return response;
  },
  editOdabypatch: async (params, data) => {
    const response = await editOdabypatch(params, data);
    return response;
  },
  deleteOda: async (params) => {
    const response = await deleteOda(params);
    return response;
  },
  exportrateOda: async (params) => {
    const response = await exportrateOda(params);
    return response;
  },
  getOdarateTemplate: async (params) => {
    const response = await getOdarateTemplate(params);
    return response;
  },
  importOda: async (params) => {
    const response = await importOda(params);
    return response;
  },
  getFuel: async (params) => {
    const response = await getFuel(params);
    return response;
  },
  getFuelbyId: async (params) => {
    const response = await getFuelbyId(params);
    return response;
  },
  postFuel: async (params) => {
    const response = await postFuel(params);
    return response;
  },
  editFuel: async (params, data) => {
    const response = await editFuel(params, data);
    return response;
  },
  editFuelbypatch: async (params, data) => {
    const response = await editFuelbypatch(params, data);
    return response;
  },
  deleteFuel: async (params) => {
    const response = await deleteFuel(params);
    return response;
  },
  exportrateFuel: async (params) => {
    const response = await exportrateFuel(params);
    return response;
  },
  getFuelrateTemplate: async (params) => {
    const response = await getFuelrateTemplate(params);
    return response;
  },
  importFuel: async (params) => {
    const response = await importFuel(params);
    return response;
  },
  getInsurance: async (params) => {
    const response = await getInsurance(params);
    return response;
  },
  getInsurancebyId: async (params) => {
    const response = await getInsurancebyId(params);
    return response;
  },
  postInsurance: async (params) => {
    const response = await postInsurance(params);
    return response;
  },
  editInsurance: async (params, data) => {
    const response = await editInsurance(params, data);
    return response;
  },
  editInsurancebypatch: async (params, data) => {
    const response = await editInsurancebypatch(params, data);
    return response;
  },
  deleteInsurance: async (params) => {
    const response = await deleteInsurance(params);
    return response;
  },
  exportrateInsurance: async (params) => {
    const response = await exportrateInsurance(params);
    return response;
  },
  getInsurancerateTemplate: async (params) => {
    const response = await getInsurancerateTemplate(params);
    return response;
  },
  importInsurance: async (params) => {
    const response = await importInsurance(params);
    return response;
  },
  getAttempts: async (params) => {
    const response = await getAttempts(params);
    return response;
  },
  getAttemptsbyId: async (params) => {
    const response = await getAttemptsbyId(params);
    return response;
  },
  postAttempts: async (params) => {
    const response = await postAttempts(params);
    return response;
  },
  editAttempts: async (params, data) => {
    const response = await editAttempts(params, data);
    return response;
  },
  editAttemptsbypatch: async (params, data) => {
    const response = await editAttemptsbypatch(params, data);
    return response;
  },
  editFreightState: async (params, data) => {
    const response = await editFreightState(params, data);
    return response;
  },
  editRtoState: async (params, data) => {
    const response = await editRtoState(params, data);
    return response;
  },
  editCodState: async (params, data) => {
    const response = await editCodState(params, data);
    return response;
  },
  editOdaState: async (params, data) => {
    const response = await editOdaState(params, data);
    return response;
  },
  editFuelState: async (params, data) => {
    const response = await editFuelState(params, data);
    return response;
  },
  editInsuranceState: async (params, data) => {
    const response = await editInsuranceState(params, data);
    return response;
  },
  editAttemptsState: async (params, data) => {
    const response = await editAttemptsState(params, data);
    return response;
  },
  deleteAttempts: async (params) => {
    const response = await deleteAttempts(params);
    return response;
  },
  exportrateAttempts: async (params) => {
    const response = await exportrateAttempts(params);
    return response;
  },
  getAttemptsrateTemplate: async (params) => {
    const response = await getAttemptsrateTemplate(params);
    return response;
  },
  importAttempts: async (params) => {
    const response = await importAttempts(params);
    return response;
  },
  getOrigin: async (params1, params) => {
    const response = await getOrigin(params1, params);
    return response;
  },
  filterOrigin: async (params1, params) => {
    const response = await filterOrigin(params1, params);
    return response;
  },
  postOrigin: async (params, data) => {
    const response = await postOrigin(params, data);
    return response;
  },
  editOrigin: async (params, params2, data) => {
    const response = await editOrigin(params, params2, data);
    return response;
  },
  deleteOrigin: async (params, params2, data) => {
    const response = await deleteOrigin(params, params2, data);
    return response;
  },
  exportOrigin: async (params1, params) => {
    const response = await exportOrigin(params1, params);
    return response;
  },
  getOriginTemplate: async (params) => {
    const response = await getOriginTemplate(params);
    return response;
  },
  importOrigin: async (params, data) => {
    const response = await importOrigin(params, data);
    return response;
  },
  getDestination: async (params1, params) => {
    const response = await getDestination(params1, params);
    return response;
  },
  filterDestination: async (params1, params) => {
    const response = await filterDestination(params1, params);
    return response;
  },
  postDestination: async (params, data) => {
    const response = await postDestination(params, data);
    return response;
  },
  editDestination: async (params, params2, data) => {
    const response = await editDestination(params, params2, data);
    return response;
  },
  deleteDestination: async (params, params2, data) => {
    const response = await deleteDestination(params, params2, data);
    return response;
  },
  exportDestination: async (params1, params) => {
    const response = await exportDestination(params1, params);
    return response;
  },
  getDestinationTemplate: async (params) => {
    const response = await getDestinationTemplate(params);
    return response;
  },
  importDestination: async (params, data) => {
    const response = await importDestination(params, data);
    return response;
  },
  getTransittime: async (params1, params) => {
    const response = await getTransittime(params1, params);
    return response;
  },
  postTransittime: async (params, data) => {
    const response = await postTransittime(params, data);
    return response;
  },
  editTransittime: async (params, params2, data) => {
    const response = await editTransittime(params, params2, data);
    return response;
  },
  deleteTransittime: async (params, params2) => {
    const response = await deleteTransittime(params, params2);
    return response;
  },
  exportTransittime: async (params1, params) => {
    const response = await exportTransittime(params1, params);
    return response;
  },
  getTransittimeTemplate: async (params) => {
    const response = await getTransittimeTemplate(params);
    return response;
  },
  importTransittime: async (params, data) => {
    const response = await importTransittime(params, data);
    return response;
  },
});

mastersStore = devtools(mastersStore);

export const useMastersStore = create(mastersStore);
